<section class="hs-events" aria-live="polite">
  <div class="hs-events__container">
    <div class="hs-events__table">
      <div class="hs-events__table-wrapper">
        <table mat-table [dataSource]="this.eventsDataSource">
          <ng-container [matColumnDef]="column" *ngFor="let column of eventColumns[this.activeTab]">
            <th mat-header-cell *matHeaderCellDef [style.text-align]="column === 'rootName' ? 'left' : 'inherit'">
              {{
                column === 'rootName'
                  ? 'Employer'
                  : column === 'lastLocation'
                    ? 'Last Location'
                    : column === 'plannedLocation'
                      ? 'Planned Location'
                      : column === 'nextDueDate'
                        ? 'Due'
                        : column === 'actualDate'
                          ? 'Last Done'
                          : column === 'plannedDate'
                            ? 'Next Planned'
                            : column === 'lastEvent'
                              ? 'Last Event'
                              : column === 'plannedEvent'
                                ? 'Planned Event'
                                : this.sharedService.uppercaseWords(column | unCamelCase)
              }}
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="column">
                <ng-container *ngSwitchCase="'rootName'">
                  <a [routerLink]="['/employer/health-and-safety', element.rootId]" target="_blank">
                    {{
                      this.sharedService.isNullOrEmpty(element[column])
                        ? '-'
                        : this.sharedService.uppercaseWords(element[column])
                    }}
                  </a>
                </ng-container>

                <ng-container *ngSwitchCase="'lastEvent'">
                  <div class="actions-container">
                    <button
                      *ngIf="element.actualId !== null"
                      class="action-button view"
                      aria-label="Open event"
                      matTooltip="Open event"
                      matTooltipPosition="left"
                      (click)="handleOpenEventForm(element, element.actualId)"
                    >
                      <mat-icon>open_in_new</mat-icon>
                      <mat-progress-bar
                        *ngIf="loadingEvent === element"
                        mode="indeterminate"
                        class="button-progress-bar"
                      ></mat-progress-bar>
                    </button>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'plannedEvent'">
                  <div class="actions-container">
                    <button
                      *ngIf="element.plannedId !== null"
                      class="action-button view"
                      aria-label="Open event"
                      matTooltip="Open event"
                      matTooltipPosition="left"
                      (click)="handleOpenEventForm(element, element.plannedId)"
                    >
                      <mat-icon>open_in_new</mat-icon>
                      <mat-progress-bar
                        *ngIf="loadingEvent === element"
                        mode="indeterminate"
                        class="button-progress-bar"
                      ></mat-progress-bar>
                    </button>

                    <button
                      *ngIf="element.plannedId === null"
                      class="action-button add"
                      aria-label="Create event"
                      matTooltip="Create event"
                      matTooltipPosition="left"
                      (click)="handleOpenEventForm(element, null)"
                    >
                      <mat-icon>add_circle</mat-icon>
                      <mat-progress-bar
                        *ngIf="loadingEvent === element"
                        mode="indeterminate"
                        class="button-progress-bar"
                      ></mat-progress-bar>
                    </button>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'actualDate'">
                  {{
                    this.sharedService.isNullOrEmpty(element[column]) ? '-' : (element[column] | date: this.dateFormat)
                  }}
                </ng-container>

                <ng-container *ngSwitchCase="'plannedDate'">
                  <span [ngClass]="{ warn: PlannedOverDueDate(element['plannedDate'], element['nextDueDate']) }">
                    {{
                      this.sharedService.isNullOrEmpty(element[column])
                        ? '-'
                        : (element[column] | date: this.dateFormat)
                    }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'type'">
                  {{
                    this.sharedService.isNullOrEmpty(element[column])
                      ? '-'
                      : element[column] === 'ELI'
                        ? 'ELI'
                        : this.sharedService.uppercaseWords(element[column])
                  }}
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{
                    this.sharedService.isNullOrEmpty(element[column])
                      ? '-'
                      : this.dateColumns.includes(column)
                        ? (element[column] | date: this.dateFormat)
                        : this.sharedService.uppercaseWords(element[column])
                  }}
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="eventColumns[this.activeTab]; sticky: true"
            [class.hs-events__row--hidden]="loading"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: eventColumns[this.activeTab]"
            [class.hs-events__row--hidden]="loading"
          ></tr>
          <tr class="mat-row" *matNoDataRow [class.hs-events__row--hidden]="loading">
            <ng-container>
              <td class="mat-cell hs-events__no-data" [attr.colspan]="eventColumns[this.activeTab]?.length || 1">
                {{ this.eventError ? this.dataError : 'No Events' }}
              </td>
            </ng-container>
          </tr>
        </table>
        <div class="hs-events__loading-overlay" *ngIf="loading">
          <div class="hs-events__loading-content">
            <mat-spinner diameter="40"></mat-spinner>
            <span class="hs-events__loading-text">Loading {{ activeTab }} Events...</span>
          </div>
        </div>
      </div>
      <mat-paginator
        class="hs-events__paginator"
        [pageSize]="this.pageSize"
        [length]="this.totalEvents"
        showFirstLastButtons
        (page)="handlePageEvent($event)"
        aria-label="Select page"
        [disabled]="this.loading"
      >
      </mat-paginator>
    </div>
  </div>
</section>
